module.exports = __webpack_public_path__ + "img/down-emoji.8e6676ed.png";